import { ObstacleSide } from './ObstacleSide';
export class LeftObstacleSide extends ObstacleSide {
    constructor(startVertex) {
        super(startVertex);
        this.end = startVertex.nextOnPolyline.point;
    }
    get End() {
        return this.end;
    }
    get EndVertex() {
        return this.StartVertex.nextOnPolyline;
    }
}
//# sourceMappingURL=LeftObstacleSide.js.map